import { render } from "./ProcessoDocumentosComponent.vue?vue&type=template&id=78f96d84&scoped=true"
import script from "./ProcessoDocumentosComponent.vue?vue&type=script&lang=js"
export * from "./ProcessoDocumentosComponent.vue?vue&type=script&lang=js"

import "./ProcessoDocumentosComponent.vue?vue&type=style&index=0&id=78f96d84&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Projetos TWM\\eproc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78f96d84"]])

export default __exports__